import { AppRoutes } from "./AppRoutes";
import { AppRoutesStartupLib } from './AppRoutesStartupLib';
import "./App.css";
import React, { Component, ErrorInfo, ReactNode } from "react";
import { useMutation } from '@apollo/client';
import { SEND_ERROR } from './apollo/queries';
import { NavBartStartupLib } from './components/NavBarStartupLib';
import styles from './pages/StartupDashboard/StartupDashboard.module.scss';
import { GreetingsHeader } from './components/common/GreetingsHeader';
interface Props {
    children?: ReactNode;
    onError?: Function
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    constructor(props: Props) {
        super(props);
    }

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error lala:", error, errorInfo);

        if(this.props.onError !== undefined) {
            this.props.onError({
                variables: {
                    input: {
                        message: error.message,
                        stacktrace: error.stack
                    }
                }
            })
        }

    }

    public render() {
        if (this.state.hasError) {
            return <>
                <NavBartStartupLib/>
                <div className={styles.wrapper}>
                    <GreetingsHeader title="Sorry... " subtitle="there was an error"/>
                </div>
                <h1 style={{ margin: 'auto', textAlign: 'center', fontSize: 18 }}>Sorry.. there was an error</h1>
                <h3 style={{ margin: 'auto', textAlign: 'center' }}>Reload the page to try again</h3>
            </>
        }

        return this.props.children;
    }
}

let App: Function;
if(process.env.REACT_APP_APPLICATION_TYPE === 'startup-library') {
    App = () => {
        const [sendError] = useMutation(SEND_ERROR)

        return (
            <ErrorBoundary onError={sendError}>
                <AppRoutesStartupLib/>
            </ErrorBoundary>
    )
    };
    } else {
        App = () => {
            const [sendError] = useMutation(SEND_ERROR)

            return (
            <ErrorBoundary onError={sendError}>
                    <AppRoutes />
            </ErrorBoundary>
        )
    }
}

export default App;
